/**
 * Validate if the input string is a valid URL
 * Ensure that each subdomain in the domain part adheres to the standard, and that dots (.) are correctly handled as separators.
 * Ensure that the top-level domain part consists of at least two letters, conforming to domain name conventions.
 * Allow URLs to include a path, while ensuring that no whitespace characters are present in the path.
 **/
export function isPossiblyURL(str: string): boolean {
  const urlPattern =
    /^(https?|ftp):\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?$/i;
  return urlPattern.test(str);
}

// Combines multiple path segments into a single, standardized path while preventing path traversal attacks.
function combine(...paths: string[]): string {
  return paths
    .map((path) =>
      // Remove leading/trailing slashes or backslashes and prevent path traversal attacks by removing all ".." and "." and their combinations
      path.replace(/^[\\|/]+|[\\|/]+$/g, "").replace(/\.\.(\/|\\)+/g, "")
    )
    .filter(Boolean) // Filter out empty segments
    .join("/") // Join segments with "/"
    .replace(/\\/g, "/"); // Replace backslashes with forward slashes
}

export async function mdcppFetchAccessToken(
  fetchAccessToken: (resourceUrl: string, claim?: string[]) => Promise<string>,
  resourceUrl: string,
  claim?: string[]
): Promise<string> {
  // Append "./default" to the resourceUrl
  const modifiedResource = combine(resourceUrl, ".default");
  // Call the original fetchAccessToken function with the modified resourceUrl
  return fetchAccessToken(modifiedResource, claim);
}
